import React, { useState, useEffect } from "react";
import { editMedia, getMedia } from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../colors/colors.css";
import Select from "react-select";
import { UserLang } from "../../store/userStore";

const VideoDetails = (props) => {
  const initState = {
    metadata: {
      custom_params: {
        Actor: "",
        AssetId: "",
        AudioTracks: "",
        ContentType: "",
        Director: "",
        ExpiresOn: "",
        Genre: "",
        MediaType: "",
        MovieId: "",
        PgRating: "",
        Plan: "",
        PortraitImage: "",
        Producer: "",
        ProductionStudio: "",
        Property: "",
        Rating: "",
        Recommendation: "",
        ReleaseOn: "",
        ReleaseType: "",
        ShortDescription: "",
        TrailerId: "",
        VIdeoDuration: "",
        Writers: "",
      },
      title: "",
    },
  };

  const menuPic = [
    {
      value: "",
      label: "No value",
    },
    {
      value: "Movie",
      label: "Movie",
    },
    {
      value: "Trailer",
      label: "Trailer",
    },
    {
      value: "Show",
      label: "Show",
    },

    {
      value: "News",
      label: "News",
    },

    {
      value: "Music",
      label: "Music",
    },
    {
      value: "Promo",
      label: "Promo",
    },
    {
      value: "Highlight",
      label: "Highlight",
    },

    {
      value: "News Show",
      label: "News Show",
    },

    {
      value: "Live",
      label: "Live",
    },

    {
      value: "Other",
      label: "Other",
    },
  ];

  const content = [
    {
      value: "",
      label: "No value",
    },
    {
      value: "Premium",
      label: "Premium",
    },
    {
      value: "Authenticated",
      label: "Authenticated",
    },
    {
      value: "Free",
      label: "Free",
    },
  ];

  const property = [
    {
      value: "",
      label: "No value",
    },
    {
      value: "Default",
      label: "Default",
    },
    {
      value: "Non DRM",
      label: "Non DRM",
    },
  ];

  const release = [
    {
      value: "",
      label: "No value",
    },
    {
      value: "Already Released",
      label: "Already Released",
    },
    {
      value: "Yet to Release",
      label: "Yet to Release",
    },
  ];

  const [medias, setMedias] = useState(initState);
  const [allIcon] = useState(menuPic);
  const [allContent] = useState(content);
  const [allProperty] = useState(property);
  const [ReleaseType] = useState(release);
  const [media, setMedia] = useState(initState);
  const [loading, setLoading] = useState(false);
  const lan = UserLang.useState((s) => s.lan);
  const { id } = props.location.state;

  const handleChange = (evt) => {
    const value = evt.target.value;

    setMedia({
      ...media,
      [evt.target.name]: value,
    });
  };

  const handleChanges = (evt) => {
    const value = evt.target.value;

    setMedias({
      ...medias,
      [evt.target.name]: value,
    });
  };

  const handleTypeChange = (value, evt) => {
    const val = value.value;
    setMedias({
      ...medias,
      [evt.name]: val,
    });
  };

  useEffect(() => {
    const mediaDetails = async (id) => {
      const result = await getMedia(id).then((result) => {
        setMedia(result);
        setMedias(result.custom_params);
      });
      setLoading(false);
    };

    mediaDetails(id);
  }, [id]);
  const mediaSave = async (event) => {
    setLoading(true);
    event.preventDefault();

    const result = await editMedia(id, media, medias).then(
      (result) => {
        toastr.success("Successfully Saved", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
  };
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Media Details
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={mediaSave}>
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Title
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="title"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChange}
                              defaultValue={media.title}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Actor
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Actor"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Actor}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Asset Id
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="AssetId"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.AssetId}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Audio Tracks
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="AudioTracks"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.AudioTracks}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Content Type
                            </label>
                            <Select
                              name="ContentType"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allContent}
                              placeholder={medias.ContentType}
                              onChange={(value, event) =>
                                handleTypeChange(value, event)
                              }
                            ></Select>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Director
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Director"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Director}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Expires On
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="ExpiresOn"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.ExpiresOn}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Genre
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Genre"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Genre}
                              onChange={handleChanges}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Media Type
                            </label>
                            <Select
                              name="MediaType"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allIcon}
                              placeholder={medias.MediaType}
                              onChange={(value, event) =>
                                handleTypeChange(value, event)
                              }
                            ></Select>

                            {/* <div className="row" style={{marginTop:'20px',backgroundColor:'#f2f2f2',marginLeft:'5px'}}>
          <div className="col-md-6" style={{marginTop:'20px',marginLeft:'2px'}}>
         <span>{medias.MediaType}</span>
         </div>
         </div> */}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Movie Id
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="MovieId"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.MovieId}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Pg Rating
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="PgRating"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={media.custom_params.PgRating}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Plan
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Plan"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Plan}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Portrait Image
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="PortraitImage"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={media.custom_params.PortraitImage}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Producer
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Producer"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Producer}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Production Studio
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="ProductionStudio"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={
                                media.custom_params.ProductionStudio
                              }
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Property
                            </label>
                            <Select
                              name="Property"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allProperty}
                              placeholder={medias.Property}
                              onChange={(value, event) =>
                                handleTypeChange(value, event)
                              }
                            ></Select>
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Rating
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="Rating"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={media.custom_params.Rating}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Recommendation
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Recommendation"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Recommendation}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Release On
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="ReleaseOn"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={media.custom_params.ReleaseOn}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Release Type
                            </label>
                            <Select
                              name="ReleaseType"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={ReleaseType}
                              placeholder={medias.ReleaseType}
                              onChange={(value, event) =>
                                handleTypeChange(value, event)
                              }
                            ></Select>
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Short Description
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="ShortDescription"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={
                                media.custom_params.ShortDescription
                              }
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Trailer Id
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="TrailerId"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.TrailerId}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {media.custom_params && (
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              VIdeo Duration
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              style={{ overFlow: "scroll" }}
                              name="VIdeoDuration"
                              className="form-control inside-form"
                              placeholder="Null"
                              onChange={handleChanges}
                              defaultValue={media.custom_params.VIdeoDuration}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          {/* text input */}
                          <div className="form-group">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Writers
                            </label>
                            <input
                              type="text"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              name="Writers"
                              className="form-control inside-form"
                              placeholder="Null"
                              defaultValue={media.custom_params.Writers}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {/* <div className="row">
      <div className="col-sm-6">
        <div className="form-group">
          <label>Menu Background Color *</label>
          <input type="text" name="menuBackgroundColor" className="form-control inside-form" placeholder="Null" defaultValue ={"#!"} onChange={handleChange}   autoComplete="off" />
          
                
        </div>
     
      </div> */}
                    {/* <div className="col-sm-6">
        <div className="form-group">
        <div className="custom-control custom-switch">
     <input type="checkbox" className="custom-control-input" name={"textShadow"} id={"textShadow"} defaultChecked={colorSchema.textShadow} onClick={(event) => updateVisiblity(event)} />
     <label className="custom-control-label not-bold" htmlFor={"textShadow"} onClick={ e => e.stopPropagation() }>Text Shadow</label>
     </div>
        </div>
     
      </div> */}
                    {/* </div> */}

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default VideoDetails;
